import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const PrivacidadePage = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/docs/politica-de-privacidade-v1.0.md')
      .then((res) => {
        if (!res.ok) {
          throw new Error('Não foi possível carregar a política de privacidade.');
        }
        return res.text();
      })
      .then((text) => {
        setContent(text);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <div className="min-h-screen bg-background text-on-surface font-sans flex flex-col">
      {/* Cabeçalho Fixo (Sticky Header) */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-background/90 backdrop-blur-xl border-b border-outline-variant/10 shadow-[0_4px_30px_rgba(0,0,0,0.03)] px-6 py-4 flex items-center justify-between transition-colors duration-200">
        <div className="max-w-6xl mx-auto w-full flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1.5 rounded-full border border-outline-variant/30 text-on-surface-variant hover:text-primary hover:border-primary/50 transition-all duration-200 bg-surface-container-low text-xs sm:text-sm font-semibold shrink-0"
          >
            <span className="material-symbols-outlined text-[16px] sm:text-[18px]">arrow_back</span>
            <span className="hidden sm:inline">Voltar</span>
          </button>
          
          <div className="flex-1 min-w-0 ml-2">
            <h1 className="font-serif text-lg md:text-xl font-bold text-primary truncate leading-none">
              Política de Privacidade
            </h1>
            <p className="text-[10px] md:text-xs text-on-surface-variant/70 uppercase tracking-widest mt-1">
              Versão 1.0 — 20 de maio de 2026
            </p>
          </div>

          <div className="hidden sm:flex items-center gap-2">
            <img alt="CatholicGPT Logo" className="w-8 h-8 rounded-full bg-white p-0.5 border border-primary/20" src="/logo-64.webp" />
            <span className="font-serif text-sm font-bold text-primary">CatholicGPT</span>
          </div>
        </div>
      </header>

      {/* Conteúdo Principal */}
      <main className="flex-grow max-w-3xl w-full mx-auto px-6 pt-24 pb-16">
        {loading ? (
          /* Skeleton Loader */
          <div className="space-y-6 animate-pulse pt-8">
            <div className="h-8 bg-surface-container-high w-3/4 rounded-xl"></div>
            <div className="h-4 bg-surface-container-high w-1/4 rounded-lg"></div>
            <div className="space-y-3 pt-4">
              <div className="h-4 bg-surface-container-high w-full rounded-lg"></div>
              <div className="h-4 bg-surface-container-high w-11/12 rounded-lg"></div>
              <div className="h-4 bg-surface-container-high w-10/12 rounded-lg"></div>
            </div>
            <div className="h-32 bg-surface-container-high w-full rounded-2xl my-8"></div>
            <div className="space-y-3">
              <div className="h-4 bg-surface-container-high w-full rounded-lg"></div>
              <div className="h-4 bg-surface-container-high w-5/6 rounded-lg"></div>
            </div>
            <div className="h-8 bg-surface-container-high w-1/2 rounded-xl mt-8"></div>
            <div className="space-y-3 pt-2">
              <div className="h-4 bg-surface-container-high w-full rounded-lg"></div>
              <div className="h-4 bg-surface-container-high w-4/5 rounded-lg"></div>
            </div>
          </div>
        ) : error ? (
          <div className="text-center py-16 pt-24 space-y-4">
            <span className="material-symbols-outlined text-error text-5xl">error</span>
            <p className="text-on-surface font-semibold text-lg">{error}</p>
            <button
              onClick={() => window.location.reload()}
              className="bg-primary text-on-primary px-6 py-2 rounded-full text-sm font-semibold hover:opacity-90 transition-opacity"
            >
              Tentar Novamente
            </button>
          </div>
        ) : (
          <article className="chat-prose text-on-surface pt-6 prose prose-invert max-w-none">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {content}
            </ReactMarkdown>
          </article>
        )}
      </main>

      {/* Rodapé Interno da Página */}
      <footer className="w-full py-8 text-center border-t border-outline-variant/10 bg-surface-container-low/50">
        <div className="text-[10px] tracking-[0.2em] text-on-surface-variant/40 uppercase font-sans">
          © 2026 CatholicGPT — Ad Maiorem Dei Gloriam
        </div>
      </footer>
    </div>
  );
};

export default PrivacidadePage;
